import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { FileMutationDto } from '../../../../config/fileConfig'
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger } from '@fluentui/react-components'
import { DeleteRegular, DismissRegular, SaveRegular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'
import { FileSurchargeDto, SurchargeAction } from './FileSurchargeList'
import FileSurchargeForm from './FileSurchargeForm'

export type SurchargeDialogProps = {
    show: boolean
    setOpen: (open: boolean) => void
    initialValues: FileSurchargeDto
    index: number
    action: SurchargeAction
}

export default function FileSurchargeDialog(props: SurchargeDialogProps): ReactElement {
    const { t: translate } = useTranslation()
    const { values, setFieldValue } = useFormikContext<FileMutationDto>()

    const removeItem = (cutIndex: number) => {
        values.surcharges = values.surcharges.filter((_, index) => index !== cutIndex)
        setFieldValue('surcharges', values.surcharges)
    }

    const resetItem = (cutIndex: number) => {
        if (props.action === SurchargeAction.ADD) {
            values.surcharges = values.surcharges.filter((_, index) => index !== cutIndex)
            setFieldValue('surcharges', values.surcharges)
        } else {
            values.surcharges[props.index] = props.initialValues
            setFieldValue(`surcharges[${props.index}]`, props.initialValues)
        }
    }

    const onDismiss = () => {
        resetItem(props.index)
        props.setOpen(false)
    }
    const onAdd = () => {
        if (!values.surcharges[props.index].surchargeType) {
            removeItem(props.index)
        }
        props.setOpen(false)
    }

    return (
        <Dialog open={props.show} onOpenChange={onDismiss}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>
                        {props.action === SurchargeAction.EDIT
                            ? translate('file.edit.form.finance.surcharge.edit')
                            : translate('file.edit.form.finance.surcharge.add')}
                    </DialogTitle>
                    <DialogContent>
                        <FileSurchargeForm {...props} onSubmit={onAdd} />
                    </DialogContent>
                    <DialogActions>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="transparent" icon={<DismissRegular />} onClick={onDismiss}>
                                {translate('action.cancel')}
                            </Button>
                        </DialogTrigger>
                        <Button icon={<SaveRegular />} appearance="primary" onClick={onAdd}>
                            {translate('action.save')}
                        </Button>
                        {props.action === SurchargeAction.EDIT && (
                            <Button
                                appearance="transparent"
                                icon={<DeleteRegular />}
                                onClick={() => {
                                    removeItem(props.index)
                                    props.setOpen(false)
                                }}
                            >
                                {translate('action.delete')}
                            </Button>
                        )}
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    )
}
